import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import getCookie from "@gerenciatd/next13.utils.common.get-cookie";
const OneTrust = dynamic(() => import("@/component/one-trust"));
import RouteHandler from "@gerenciatd/next13.core.route-handler";
import ErrorBoundary from "@/component/error-boundary";
import { actions as modalActions } from "@gerenciatd/next13.reducers.modals-reducer";
// import mainSetup from '@/config/mainSetup';
import { wrapper } from "store";
import "@/styles/globals.scss";
import "@/styles/skeleton.scss";
/* [STYLES] begins */
import '@/styles/button.style.scss';
import '@/styles/carousel.style.scss';
import '@/styles/characteristics.style.scss';
import '@/styles/custom-link.style.scss';
import '@/styles/faqs.style.scss';
import '@/styles/footer.style.scss';
import '@/styles/header.style.scss';
import '@/styles/image.style.scss';
import '@/styles/label.style.scss';
import '@/styles/modal.style.scss';
import '@/styles/offer-progress.style.scss';
import '@/styles/price.style.scss';
import '@/styles/step-list.style.scss';
import '@/styles/text.style.scss';
import '@/styles/globals.scss';
import '@/styles/grid.scss';
import '@/styles/colors.scss';
import '@/styles/fonts.scss';
/* [STYLES] ends */
import "@/styles/card.scss";

const shouldLoadDyna = (probability = 10) => {
  let res = false;
  let probability2Apply = probability;

  if (typeof window !== "undefined") {
    const cookiesAcepted = getCookie("OptanonAlertBoxClosed");
    const urlParams = new URLSearchParams(window.location.search);
    let paramValue = urlParams.get("dyna");
    if (paramValue) {
      probability2Apply = parseInt(paramValue, 10);
    }
    res = cookiesAcepted ? Math.random() < probability2Apply / 100 : false;
  }
  return res;
};

const App = ({ Component, pageProps, ...rest }) => {
  const dispatch = useDispatch();
  const Modal = useSelector((state) => state.modals.Modal);
  const [showCookies, setCookieVisibility] = useState(false);

  useEffect(() => {
    const cookiesAcepted = getCookie("OptanonAlertBoxClosed");
    const isProperEnvironment =
      `${process.env.NEXT_PUBLIC_ENV_NAME}` === "prod";
    const regularCdn = !cookiesAcepted && isProperEnvironment;
    const forceShowCookies = window.location.href.indexOf("showCookies") > -1;
    if (regularCdn || forceShowCookies) {
      setCookieVisibility(true);
    }

    if (shouldLoadDyna()) {
      var dynaScript = document.createElement("script");
      dynaScript.setAttribute(
        "src",
        "https://prod.cms.col.movistar.es/static/js/dynatrace/dyna.js"
      );
      dynaScript.setAttribute("async", "true");
      dynaScript.setAttribute("defer", "true");
      dynaScript.setAttribute("crossorigin", "anonymous");
      document.body.appendChild(dynaScript);
    }
  }, []);

  return (
    <>
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && (
          <Modal
            addModal={(data) => {
              dispatch(modalActions.addModal(data));
            }}
          />
        )}
        {showCookies && <OneTrust />}
      </ErrorBoundary>
    </>
  );
};

export default wrapper.withRedux(App);
